import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Login from "./pages/loginPage/loginPage.js";
import ForgotPassword from "./pages/forgotPassword/forgotPassword.js";

import LandingPage from "./pages/landingPage/index.js";
import MainLayout from "./layouts/MainLayout.js";
//import AdminLayout from './pages/layouts/AdminLayout.js'

import Register from "./pages/registerPage/register.js";
import GridPage from "./pages/gridPage/gridPage.js";
import ProfilePage from "./pages/profilePage/userProfile.js";
import AdminPage from "./pages/adminPage/adminPage.js";
import AdminUsers from "./pages/adminPage/adminUsers.js";
import AdminSettings from "./pages/adminPage/adminProfilePage.js";
import "./App.css";
import { jwtDecode } from "jwt-decode";

import { cookies } from "./utils/cookie";
import Dashboard from "./pages/monitorPage/monitorPage.js";
import ResetPassword from "./pages/resetPasswordPage/resetPassword.js";
import NewMonitorPage from "./pages/monitorPage/newMonitorPage.js";
import NewUser from "./pages/adminPage/newUser.js";
import UserDetail from "./pages/adminPage/userDetail.js";
import AdmimMonitors from "./pages/adminPage/adminMonitorPage.js";
import VerifyEmailPage from "./pages/verifyEmailPage/verifyEmailPage.js";
import MonitorDetail from "./pages/monitorPage/monitorDetail.js";
import AdminLayout from "./layouts/AdminLayout.js";
import AdminUserMonitorDetail from "./pages/adminPage/adminUserMonitorDetail.js";
import PlanCreationPage from "./pages/adminPage/planManagePage.js";
import SubscriptionPage from "./pages/subscriptionPage/subscriptionPage.js";
import ModernDashboard from "./pages/monitorPage/claudeMonitoringPage.js";
import ModernNewMonitorPage from "./pages/monitorPage/claudeNewMonitor.js";
import ModernNewMonitorPage2 from "./pages/monitorPage/newMonitor.js";
import { useDispatch, useSelector } from 'react-redux'
import { loginThunk } from './redux/features/auth/authThunks'
import { selectUser, selectIsLoggedIn } from './redux/features/auth/authSelectors'
import ModernProfilePage from "./pages/profilePage/profile.js";
import MaintenancePage from "./pages/maintanancePage/maintanancePage.js";

const NotFound = () => {
  return (
    <div
      style={{
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        display: "flex",
        mt: "10%",
        gap: 10,
      }}
    >
      <h1 style={{ gap: 1, display: "flex" }}>
        Aradığınız sayfa bulunamadı veya bu sayfayı görmeye yetkiniz yok.{"\t"}
      </h1>
    </div>
  );
};

function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(loginThunk())
  }, [])

  // Rota değişince sayfayı en üste kaydır (SPA scroll restorasyonu)
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  useEffect(() => {
    const checkAuth = async () => {
      const jwtToken = cookies.get("jwt-access");
      if (jwtToken && !location.pathname.includes("/verify-email")) {
        const decodedToken = jwtDecode(jwtToken);
        const userRole = decodedToken.role;
        if (userRole === "admin" && !location.pathname.startsWith("/admin")) {
          navigate("/admin");
        } else if (
          userRole === "user" &&
          !location.pathname.startsWith("/user")
        ) {
          navigate("/user");
        } else if (
          userRole === "user" &&
          location.pathname.startsWith("/admin")
        ) {
          navigate("/NotFound");
        }
      } else if (!jwtToken) {
        if (
          ![
            "/register",
            "/forgot-password",
            "/reset-password",
            "/login",
            "/verify-email",
            "/",
          ].includes(location.pathname)
        ) {
          navigate("/");
        }
      }
      setIsLoading(false);
    };
    checkAuth();
  }, [navigate, location]);

  if (isLoading) {
    return <div>...</div>; // veya bir yükleme spinner'ı
  }

  return (
    <Routes>
      <Route index element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/register" element={<Register />} />
      <Route path="/user/verify-email" element={<VerifyEmailPage />} />

      <Route path="/" element={<MainLayout />}>
        <Route path="/user/profile" element={<ModernProfilePage />} />
        <Route path="/user/subscription" element={<SubscriptionPage />} />
        <Route path="/user/gridPage" element={<GridPage />} />
        <Route path="/user/maintenance" element={<MaintenancePage />} />
        <Route path="/user/" element={<Dashboard />} />
        <Route path="/user/monitors" element={<Dashboard />} />
        <Route path="/user/monitors-new" element={<ModernDashboard />} />
        <Route path="/user/monitors/:id/detail" element={<MonitorDetail />} />
        <Route path="/user/monitors/new/monitor" element={<NewMonitorPage />} />
        <Route path="/user/monitors/new/monitor2" element={<ModernNewMonitorPage />} />
        <Route path="/user/monitors/new/monitor3" element={<ModernNewMonitorPage2 />} />
        <Route
          path="/user/monitors/:id/monitor"
          element={<NewMonitorPage update={true} />}
        />
        <Route path="*" element={<NotFound />} />
      </Route>

      <Route path="/" element={<AdminLayout />}>
        <Route path="/admin" element={<AdminUsers />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/packages" element={<PlanCreationPage />} />
        <Route path="/admin/userMonitors/:userId" element={<AdmimMonitors />} />
        <Route
          path="/admin/userMonitors/:userId/:id/detail"
          element={<AdminUserMonitorDetail />}
        />
        <Route path="/admin/userDetail/:userId" element={<UserDetail />} />

        <Route path="/admin/newUser" element={<NewUser />} />
        <Route
          path="/admin/userMonitors/:userId/new/monitor"
          element={<NewMonitorPage />}
        />
        <Route
          path="/admin/userMonitors/:userId/:id/monitor"
          element={<NewMonitorPage update={true} />}
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
